import { ApiError } from '@/api/client'
import { useAuth } from '@/api/auth'

export type WarehouseCompany = 'stahlia' | 'priostahl'
export type WarehouseCompanyFilter = WarehouseCompany | 'both'

/** Match the server's real web role scope. A selector never grants permission. */
export function useWarehouseCompanyScope(company?: WarehouseCompanyFilter) {
  const { user, warehouse } = useAuth()
  const effective = warehouse.lead ? company ?? 'both' : 'stahlia'
  return { company: effective, key: [user?.id ?? null, warehouse, effective],
    query: effective === 'both' ? '' : `company=${effective}` }
}

export function isCompanyReviewPending(error: unknown): boolean {
  return error instanceof ApiError && !error.undecodable &&
    ['company_review_pending', 'company_unresolved'].includes(String(error.details['code'] ?? error.code))
}

export function warehouseErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const code = error.details['code'] ?? error.code
    if (code === 'company_review_pending' || code === 'company_unresolved')
      return 'Artikel-Zuordnung noch ungeklärt. Lagerleiter informieren; erst nach Prüfung erneut versuchen.'
    if (error.status === 403) return 'Keine Freigabe für diese Firma oder Aktion. Ansicht neu laden oder Lagerleiter informieren.'
  }
  return error instanceof Error ? error.message : 'Lagerdaten konnten nicht geladen werden.'
}
